import axios from 'axios'
import { notification } from 'ant-design-vue'

function request (options) {
  return axios(options)
    .then(res => {
      console.log('res:', res)
      if (res.data.needRedirect != null && res.data.needRedirect) {
        window.location.href = res.data.redirectUrl
      } else if (res.data.hasError && res.data.errors[0].code === '302') {
        notification.warn({
          key: 'sso_invalid',
          message: '登陆状态失效提醒',
          description: '您当前登陆已失效，点击跳转登陆',
          onClick: function onOk () {
            window.location.reload()
          }
        })
        return Promise.reject(res)
      } else if (res.data.hasError && res.data.errors[0].code === '402' && res.data.redirectUrl) {
        window.location.href = res.data.redirectUrl
      } else if (res.data.hasError && res.data.errors[0].code === '404' && res.data.redirectUrl) {
        window.location.href = res.data.redirectUrl
      }
      return res
    })
    .catch(error => {
      console.log('error:', error)
      console.log('options:', options)
      const {
        response: { status, statusText, data }
      } = error
      console.log(data)
      notification.error({
        // eslint-disable-next-line no-unused-vars
        message: h => (<div>请求出错:<span style="color: red"></span>{' '}: {options.url}<span>{data}</span></div>), description: statusText
      })
      return Promise.reject(error)
    })
}
export default request



// WEBPACK FOOTER //
// ./src/utils/request.js